module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": "approveState"
    }
  }, _vm._l((_vm.stateList), function(state, index) {
    return _c('div', {
      key: state.Status,
      staticClass: "nodelist"
    }, [_c('div', {
      staticClass: "node"
    }, [_c('i', {
      staticClass: "node-icon",
      class: {
        'icon-approving': (state.Status !== 2 && state.Status !== 0), 'icon-approved': state.Status === 2, 'icon-submit': state.Status === 0
      }
    }), _vm._v(" "), _c('ul', [_c('li', {
      staticClass: "owner"
    }, [_vm._v(_vm._s(state['OwneridName']))]), _vm._v(" "), _c('li', {
      staticClass: "date"
    }, [_vm._v(_vm._s(state['ApproveDate']))])])]), _vm._v(" "), (index !== _vm.stateList.length - 1) ? _c('div', {
      staticClass: "proce"
    }, [_c('span', [_vm._v("- - - - - - - ")])]) : _vm._e()])
  })), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('History')))]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "approveTrack"
    }
  }, [_c('ul', _vm._l((_vm.trackList), function(track, index) {
    return _c('li', {
      key: track.Date,
      class: {
        last: index === _vm.trackList.length - 1
      }
    }, [_c('div', {
      staticStyle: {
        "margin-top": "-7px"
      }
    }, [_c('i', {
      staticClass: "node-icon",
      class: {
        first: index === 0
      }
    }), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "date"
    }, [_vm._v(_vm._s(track['Date']))]), _vm._v(" "), _c('span', {
      staticClass: "action"
    }, [_vm._v("[" + _vm._s(track['ActionType']) + "]")]), _vm._v(" "), _c('span', {
      staticClass: "step"
    }, [_vm._v(_vm._s(track['StepIdName']))]), _vm._v(" "), _c('span', {
      staticClass: "owner"
    }, [_vm._v(_vm._s(track['OwneridName']))])]), _vm._v(" "), _c('div', {
      staticClass: "memo"
    }, [_c('span', [_vm._v(_vm._s(track.Memo))])])])])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3361d532"}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/approval/src/progress.vue
// module id = 680
// module chunks = 220